<template>
  <div class="main_center">
    <div class="content">

      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
            <el-col :span="7">
                <el-form-item label="年份：" style="margin-bottom: 10px">
                    <el-select v-model="form.year" value-key="value" style="width:100%;"  @change="yearsChange">
                        <el-option v-for="(item,index) in yearsList"
                                   :key="index"
                                   :label="item"
                                   :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="7" :offset="1">
                <el-form-item label="编号：" >
                    <el-input v-model="form.bidCode" clearable @keydown.enter.native.stop="getDataList"></el-input>
                </el-form-item>
            </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="名称：" >
              <el-input v-model="form.bidName" clearable @keydown.enter.native.stop="getDataList"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="moreSearchItem">
            <el-form-item label="状态：" props="state">
              <el-select v-model="form.state" clearable value-key="value" style="width:100%;"  @change="seachBtn">
                <el-option label="全部" value="-99"></el-option>
                <el-option v-for="(item,index) in stateslist" :key="index" :label="item.name"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1" v-if="moreSearchItem">
            <el-form-item label="交易中心：">
              <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div style="float:right;margin-bottom: 10px" >
           <el-button size="mini" type="text" v-if="!moreSearchItem" @click="moreSearchItem = true"
                       icon="el-icon-arrow-down">展开
            </el-button>
            <el-button size="mini" type="text" v-if="moreSearchItem" @click="moreSearchItem = false"
                       icon="el-icon-arrow-up">收起
            </el-button>
            <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
          </div>
            <el-col :span="18" style="margin-bottom: 10px">
                <!--        <el-button size="small"  icon="el-icon-plus" type="primary" @click="routerAdd">新增</el-button>-->
                <!--        <el-button size="small" icon="el-icon-delete" type="primary" v-if="hasBtnPermission('btn_jz_wintessdataQuest_del')"-->
                <!--                   @click="deleteSelectItem()">删除-->
                <!--        </el-button>-->
                <el-button size="small" icon="el-icon-refresh" v-if="hasBtnPermission('btn_jz_wintessdataQuest_update')" type="primary"
                           @click="synchroUpdate()">同步更新
                </el-button>
            </el-col>
        </el-row>

      </el-form>



      <el-table :data="tableData"
                ref="multipleTable"
                :height="tableMaxHeight" stripe border
                v-loading="dataListLoading"
                @selection-change="handleSelectionChange">
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
<!--        <el-table-column fixed type="selection" align="center"
                         :show-overflow-tooltip='true'></el-table-column>-->
        <el-table-column label="操作" fixed align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text"  :title="scope.row.state == '-1'?'申请':'查看'"  @click="routerDetail(scope.row)">{{scope.row.state == -1?'申请':'查看'}}</el-button>
<!--            <el-button type="text" title="删除" v-if="hasBtnPermission('btn_jz_wintessdataQuest_del')" @click="deleteById(scope.row)">-->
<!--              删除-->
<!--            </el-button>-->
          </template>
        </el-table-column>


        <el-table-column label="招标项目（标段）名称" prop='bidName' header-align="center" align="left" min-width='180'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="招标项目（标段）编号" prop='bidCode' header-align="center" align="center" min-width='180'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="项目受理时间" prop='projectHandleTime' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="中标通知书发起时间" prop='noficationTime' header-align="center" align="center" min-width='160'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="交易周期（天）" prop='busCycle' header-align="center" align="center" min-width='120'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="状态" prop='stateName' header-align="center" align="center" min-width='80'
                         :show-overflow-tooltip='true'>
            <template slot-scope="scope" >
                <el-tag  size="small" :hit="false" :type="formatterTagType(scope.row.state,'cateQuestState')" effect="plain"  > {{scope.row.stateName}}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="申请时间" prop='cateoutQuest.questTime' header-align="center" align="center" min-width='160'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="出证时间" prop='cateoutQuest.processinstanceEndDate' header-align="center" align="center" min-width='160'
                         :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
      <!-- <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
            </pagination>              
                     
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";
    import {nearSixYearsList} from '@/utils/index';
    import Pagination from '@/components/Pagination.vue';
    export default {
        components:{Pagination},
    data() {
        return {
        tableMaxHeight: document.documentElement.clientHeight - 275,
        dataListLoading: false,
            yearsList:[],
        form: {
            year:new Date().getFullYear(),
            bidName:'' ,
            bidCode:'',
            state:'-99',
            tradeId: '', // 交易中心ID
        },
        moreSearchItem: false,
        checkList1: '',
        pageSize: 10,//每页条数
        pageIndex: 1,//当前页
        total: 0,//总条数
        tableData: [],
        multipleSelection: [],
        user: '', //角色类型
        formData: {},
        stateslist:[],
        transactionCenterList: [],
        }
    },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
    created() {
        this.getDic('jz_dgwitness_catequest_state');
        this.yearsList = nearSixYearsList(this.form.year)
        this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
    },

  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    //this.reflash();
    this.getDataList();
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      let hasBtnPermisson = this.hasBtnPermission("btn_jz_wintessdataQuest_update");
      let tableMaxHeight = document.documentElement.clientHeight - 275 +  (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
        this.$nextTick(() => {
            this.tableMaxHeight = tableMaxHeight
        })
      // this.getDataList()
    },


    getDic(type) { // 获取字典

      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_catequest_state':
              this.stateslist = res.data.data;
              break;
          }
        }
      })
    },

      yearsChange(val){
          this.yearsList = nearSixYearsList(val)
          this.getDataList()
      },

    getDataList() { // 获取列表数据
        this.dataListLoading=true;
      this.$http.post('/cateQuestBase/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': '',
        'filter':// this.form
            {
                state:this.form.state=="-99"?"":this.form.state,
                bidName:this.form.bidName,
                bidCode:this.form.bidCode,
                year:this.form.year,
                tradeId: this.form.tradeId
            }
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
          this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    seachBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    reflash() {//刷新按钮
        this.pageIndex = 1;
      this.$refs['form'].resetFields();

      this.form.bidName = "";
      this.form.bidCode = "";
      this.form.state='-99',
      this.form.tradeId = ''
      this.getDataList()

    },



    routerDetail(item){ // 跳转详情

        if(item.state == '-1' && !item.noficationTime){ // 申请
            this.$message({
                type: 'error',
                message: '中标通知书发起时间为空，不可发起申请。'
            })
            return
        }

      var id = item.id;
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name:'catequest_base_detail',
        query:{
          id:item.id
        }
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
      this.$http.post('/cateQuestBase/delete', {
        id: item.id
      }).then(res => {
        if (res.data.code == '1') {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.getDataList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$http.post('/cateQuestBase/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },


    synchroUpdate() {
        this.$http.get('/cateQuestBase/synchroUpdate').then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
        },


  }


}
</script>

<style lang="less">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>